/*!
*
*
* VERSION: 1.0.0
* DATE: 2018-10-18
* @author: Jon Chandler, jonc@mcsaatchi.com
*
*
**/

if (!Array.from) {
  Array.from = function (children) {
    return Array.prototype.slice.call(children)
  };
}


// EH?? Can this be moved, please? JON
import 'babel-polyfill'

if (window.Element && !Element.prototype.closest) {
    Element.prototype.closest =
    function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i,
            el = this;
        do {
            i = matches.length;
            while (--i >= 0 && matches.item(i) !== el) {};
        } while ((i < 0) && (el = el.parentElement));
        return el;
    };
}

(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('append')) {
      return;
    }
    Object.defineProperty(item, 'append', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function append() {
        var argArr = Array.prototype.slice.call(arguments),
          docFrag = document.createDocumentFragment();

        argArr.forEach(function (argItem) {
          var isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });

        this.appendChild(docFrag);
      }
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

import { addSearch } from './search.js'
import { addDropDown } from './drop-down.js'
import { addCarousel } from './carousel.js'
import { addNutritionToggle } from './nutrition.js'
import { addTimeline } from './timeline.js'
import { loadYoutubeApi } from './youtubeApi.js'
import { addVideoPlayer } from './videoPlayer.js'
import { addInViewCheck } from './in-view.js'
import { addMobileNav } from './mobile-nav.js'
import { getFilterParams, flipContentPosition, returnImageBrightness, buyNowPopup, skipContent, languageChoice, scrollToCoordinate } from './utils.js'
import { addRecipeInfo } from './recipe-info.js'
import { addNewsletterForm } from './newsletter.js'
import { addWhereToBuyForm } from './where-to-buy.js'
import { addLoadMore } from './load-content.js'
import { addParallax } from './parallax.js'
import { addContactForm } from './contact-form.js'
import { addHeaderAnimation } from './header-animation.js'
//import { addStoreLocator } from './store-locator.js'
//import { addStoreLocator, listStores } from './store-locator.js'
//import { addStoreLocator, listStores } from './signup.js'


let gridCount = 0

Array.from(document.querySelectorAll('.video-player')).forEach(addVideoPlayer)


Array.from(document.querySelectorAll('.product_ingredients-carousel')).forEach((el) => {
  addCarousel(el)
})

Array.from(document.querySelectorAll('.nutrition-toggle')).forEach((el) => {
  addNutritionToggle(el)
})

Array.from(document.querySelectorAll('.timeline-wrapper')).forEach((el) => {
  addTimeline(el)
})

Array.from(document.querySelectorAll('section, .newsletter-sign-up')).forEach((el) => {
  addInViewCheck(el)
})

Array.from(document.querySelectorAll('.recipe-info')).forEach((el) => {
  addRecipeInfo(el)
})

Array.from(document.querySelectorAll('.flip-flop')).forEach((el) => {
	flipContentPosition(el, gridCount++)
})

Array.from(document.querySelectorAll('.newsletter-sign-up')).forEach((el) => {
	addNewsletterForm(el)
})

Array.from(document.querySelectorAll('.where-to-buy-sign-up')).forEach((el) => {
  addWhereToBuyForm(el)
})

Array.from(document.querySelectorAll('.header-block, .product-header, .banner, .recipe__head')).forEach((el) => {
  let img = el.style.backgroundImage.slice(4, -1).replace(/"/g, "")
  let elem = el
  let nextEl = el.nextElementSibling

  if(document.getElementsByClassName('recipe-block').length > 0) {
    if(nextEl.classList.contains('recipe-block')) {
      elem = el.nextElementSibling
    }
  }

  returnImageBrightness(elem, img)
})

Array.from(document.querySelectorAll('.newsletter-sign-up')).forEach((el) => {
  addNewsletterForm(el)
})

Array.from(document.querySelectorAll('.recipe-list .grid__inner, .our-food .grid__inner, .search-results .grid__inner, .news')).forEach((el) => {
  addLoadMore(el)
})


Array.from(document.querySelectorAll('.page-header, .hero__paragragh, .recipe__ingredients, .recipe__method, .quote-block.homepage, .quote-block.homepage .quote-block-icon, .meal-icon')).forEach((el) => {
  addParallax(el)
})


Array.from(document.querySelectorAll('.contact-us')).forEach((el) => {
  addContactForm(el)
})


Array.from(document.querySelectorAll('.content-skip')).forEach((el) => {
  skipContent(el)
})

Array.from(document.querySelectorAll('.flag-active')).forEach((el) => {
  languageChoice(el)
})

const headerAnim = document.querySelector('.homepage-banner-animated')
addHeaderAnimation(headerAnim, window.animationIDs)

/*const storeLocator = document.getElementById('map')
addStoreLocator(storeLocator)
*/
/*const storeList = document.querySelector('.store-list')
listStores(storeList)
*/
let buyNow = document.querySelectorAll('.buyNowPopup')
buyNowPopup( Array.from(buyNow) )

loadYoutubeApi()
addSearch()
addMobileNav()

getFilterParams(window.location.search)






// WEBPACK FOOTER //
// ./src/main.js